import React from 'react'
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Button } from '@mui/material';

const useStyles = makeStyles(theme => ({
    holder: {
        display: 'flex',
        flexDirection: 'row',
    },
    right: {
        height: 'fit-content',
        flex: 1,
        right: 0,
        flexDirection: 'row',
        marginRight: 0,
        paddingLeft: 20,
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 'auto',
    },
    qty: {
        paddingRight: 5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    unverified: {
        color: "red"
    }
}));

export default function IngredientBig({ ingredient, multiFactor, addToCart, unverified, capitalize, handleQty, update }) {
    const classes = useStyles();
    // Compute once so the Select + MenuItems can use it
    const computedQty = ingredient.qty * multiFactor;
    const isPlural = computedQty > 1;
    const hasValidTypes = ingredient.validTypes && ingredient.validTypes.length > 0;

    // Format qtyType for display when no valid types available
    const formatQtyType = (qtyType) => {
        if (!qtyType) return '';
        return qtyType.charAt(0) + qtyType.slice(1).toLowerCase().replace(/_/g, ' ');
    };

    return (
        <div className={`${classes.holder} ${unverified ? classes.unverified : ""}`}>
            <div className={classes.qty}>
                <Typography className={classes.left} variant="body1">
                    {capitalize(ingredient.name)}
                </Typography>
            </div>

            <div className={classes.right}>
                <div className={classes.qty}>
                    <Typography variant="body1">{handleQty(computedQty)}</Typography>
                </div>

                {hasValidTypes ? (
                    <Select
                        MenuProps={{ MenuListProps: { dense: true } }}
                        value={ingredient.qtyType}
                        onChange={(x) => update(x.target.value)}
                        inputProps={{ 'aria-label': 'Without label' }}
                        variant="standard"
                        disableUnderline
                        sx={{
                            minWidth: 90,
                            fontSize: '0.875rem',
                            '.MuiSelect-select': { padding: '7px 20px 7px 5px', textAlign: 'left' }
                        }}
                    >
                        {ingredient.validTypes.map(qtyType => {
                            const pluralSuffix = qtyType.qtyTypeNice.qtyTypePlural ?? '';
                            const label = isPlural
                                ? `${qtyType.qtyTypeNice.qtyTypeNice}${pluralSuffix}`
                                : qtyType.qtyTypeNice.qtyTypeNice;

                            return (
                                <MenuItem key={qtyType.qtyType} value={qtyType.qtyType}>
                                    {label}
                                </MenuItem>
                            );
                        })}
                    </Select>
                ) : (
                    <Typography variant="body1" sx={{ minWidth: 90, padding: '7px 5px', textAlign: 'left' }}>
                        {formatQtyType(ingredient.qtyType)}
                    </Typography>
                )}

                {addToCart && (
                    <Button
                        disabled={ingredient.amazonUrl !== null}
                        variant="contained"
                        color="primary"
                        target="_blank"
                        onClick={x => window.open(ingredient.amazonUrl, 'newwindow', 'width=1000,height=1000')}
                    >
                        Buy Now
                    </Button>
                )}
            </div>
        </div>
    )
}
